import type { VehicleId } from '../../types/gcs/vehicle';
import type { GcsData } from '../../types/gcs/gcsData';
import { Connected } from '../../types/general/connectionState';
import { MissionFailureMode } from '../../types/gcs/mission';

/**
 * Selector to determine if a vehicle is connected
 * A vehicle is considered connected if:
 * - The GCS is connected, AND
 * - The vehicle does not have UNKNOWN_VEHICLE_DISCONNECTED failure mode
 *
 * @param data - The GCS data map from the store
 * @param gcsId - The GCS ID
 * @param vehicleId - The vehicle ID
 * @returns true if the vehicle is connected
 */
export function selectIsVehicleConnected(data: Map<string, GcsData>, gcsId: string, vehicleId: VehicleId): boolean {
  const gcsData = data.get(gcsId);
  if (!gcsData) return false;

  // Check GCS connection state
  const isGcsConnected = gcsData.connectionState instanceof Connected;

  if (!isGcsConnected) return false;

  // Check vehicle failure mode for UNKNOWN_VEHICLE_DISCONNECTED
  const liveMission = gcsData.liveMissionsMap.get(vehicleId);
  if (liveMission) {
    const missionDetailedState = gcsData.missionDetailedStateMap.get(liveMission.missionId);
    if (missionDetailedState?.failureMode === MissionFailureMode.UNKNOWN_VEHICLE_DISCONNECTED) {
      return false;
    }
  }

  return true;
}
